export default __webpack_public_path__ + "static/media/roden-analiticar.8110e2f2.gif";